<template>
  <b-modal @hidden="$emit('close')" :title="card.cardId ? 'Edytuj kartę' : 'Dodaj kartę'" @show="getCompanies" v-model="localShow" @ok="card.cardId ? editCard() : addCard()">
    <h6 class="text-muted">{{ user.firstName }} {{ user.lastName }}</h6>
    <b-form-group label="Numer karty">
      <app-input :model="$schema.cardNumber"></app-input>
    </b-form-group>
    <b-form-group label="Firma">
      <div v-for="company in companies" :key="company.id">
        <app-radio :model="$schema.companyId" :value="company.id">&nbsp;{{ company.name }}</app-radio>
      </div>
    </b-form-group>

    <span slot="modal-cancel">Anuluj</span>
    <span slot="modal-ok">Zapisz</span>
  </b-modal>
</template>
<script>
import Loader from '@/components/Loader.vue';

import formMixin from '@/mixins/formMixin';

import schema from '@/schemas/card.schema';
import { CompanyResource } from '@/resources/company.resource';
import { CardResource } from '@/resources/card.resource';

export default {
  mixins: [formMixin],
  schema,
  components: {
    Loader
  },
  props: ['show', 'cardToEdit', 'user'],
  data() {
    return {
      showLoader: true,
      localShow: false,
      companies: null,
      card: {
        cardId: null,
        companyId: null,
        number: null
      }
    };
  },
  methods: {
    async getCompanies() {
      this.companies = await CompanyResource.listSimple();
    },
    async editCard() {
      if (this.$schema.$validateAll().length === 0) {
        const editedCard = await CardResource.update(this.card.cardId, this.$schema, this.user.id);
        this.$notify({ title: 'Sukces', type: 'success', text: 'Pomyślnie edytowano kartę' });
        this.$emit('cardEdited', editedCard);
      } else {
        this.$notify({ title: 'Błąd', type: 'error', text: 'Formularz nie został wypełniony prawidłowo' });
      }
    },
    async addCard() {
      if (this.$schema.$validateAll().length === 0) {
        const addedCard = await CardResource.add(this.$schema, this.user.id);
        this.$emit('cardAdded', addedCard);
        this.$notify({ title: 'Sukces', type: 'success', text: 'Pomyślnie dodano kartę' });
      } else {
        this.$notify({ title: 'Błąd', type: 'error', text: 'Formularz nie został wypełniony prawidłowo' });
      }
    }
  },
  watch: {
    show(show) {
      this.localShow = show;
    },
    cardToEdit(val) {
      if (val.cardId) {
        this.card = val;
        this.$schema.$model.cardNumber = val.number;
        this.$schema.$model.companyId = val.companyId;
      }
    }
  }
};
</script>
